<template>
  <div class="modal">
    <div class="modal-content">
      <h1
        class="w-full mb-6 text-xl font-semibold tracking-wide text-gray-800 uppercase"
      >
        {{ $t('modals.user.passwordResetTitle') }}
      </h1>

      <alert
        v-if="errorMessage"
        type="error"
      >
        {{ errorMessage }}
      </alert>

      <p
        class="mt-4"
      >
        {{ $t('modals.user.passwordResetText') }}
      </p>

      <p class="mt-2">
        {{ $t('modals.user.passwordResetText2') }}
      </p>
    </div>

    <div class="modal-footer">
      <button
        class="btn-inline"
        @click="$emit('close')"
      >
        {{ $t('common.cancel') }}
      </button>
      <button
        :disabled="isSubmitting"
        class="btn-danger"
        @click="submit()"
      >
        {{ $t('modals.user.passwordResetSend') }}
      </button>
    </div>
  </div>
</template>

<script>
import Alert from '@/components/alert'
import SEND_USER_PASSWORD_RESET_MAIL from '@/graphql/SendUserPasswordResetMail.gql'

export default {
  components: {
    Alert
  },
  props: {
    userId: {
      type: String,
      required: true
    }
  },
  data: () => ({
    errorMessage: null,
    isSubmitting: false
  }),
  methods: {
    async submit () {
      try {
        this.isSubmitting = true

        await this.$apollo.mutate({
          mutation: SEND_USER_PASSWORD_RESET_MAIL,
          variables: {
            userId: this.userId
          }
        })

        this.$emit('close')
        this.isSubmitting = false
      } catch (err) {
        this.errorMessage = this.$t('modals.user.passwordResetError', { error: err.message })
        this.isSubmitting = false
      }
    }
  }
}
</script>
